{
    "address": "XPC1MM4dYACDfykNuXYZ5una2DsMDWL24CrYubCvarC",
    "metadata": {
        "name": "exponent_clmm",
        "version": "0.1.0",
        "spec": "0.1.0",
        "description": "Created with Anchor"
    },
    "instructions": [
        {
            "name": "add_farm",
            "discriminator": [
                7
            ],
            "accounts": [
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "signer",
                    "signer": true
                },
                {
                    "name": "fee_payer",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "mint_new"
                },
                {
                    "name": "token_source",
                    "writable": true
                },
                {
                    "name": "token_farm",
                    "writable": true
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "system_program"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "token_rate",
                    "type": "u64"
                },
                {
                    "name": "until_timestamp",
                    "type": "u32"
                }
            ],
            "returns": {
                "defined": {
                    "name": "AddFarmEvent"
                }
            }
        },
        {
            "name": "add_liquidity",
            "discriminator": [
                25
            ],
            "accounts": [
                {
                    "name": "owner",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "lp_position",
                    "writable": true
                },
                {
                    "name": "token_pt_src",
                    "writable": true
                },
                {
                    "name": "token_sy_src",
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "writable": true
                },
                {
                    "name": "address_lookup_table",
                    "docs": [
                        "Address lookup table for vault"
                    ]
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "instructions_sysvar"
                },
                {
                    "name": "system_program"
                },
                {
                    "name": "rent"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "max_sy_in_to_add",
                    "type": "u64"
                },
                {
                    "name": "max_pt_in_to_add",
                    "type": "u64"
                },
                {
                    "name": "lower_tick_key_optional",
                    "type": {
                        "option": "u32"
                    }
                },
                {
                    "name": "upper_tick_key_optional",
                    "type": {
                        "option": "u32"
                    }
                }
            ],
            "returns": {
                "defined": {
                    "name": "DepositLiquidityReturnData"
                }
            }
        },
        {
            "name": "add_market_emission",
            "discriminator": [
                8
            ],
            "accounts": [
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "signer",
                    "signer": true
                },
                {
                    "name": "fee_payer",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "mint_new"
                },
                {
                    "name": "token_emission",
                    "writable": true
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "system_program"
                }
            ],
            "args": [
                {
                    "name": "cpi_accounts",
                    "type": {
                        "defined": {
                            "name": "CpiAccounts"
                        }
                    }
                }
            ]
        },
        {
            "name": "buy_pt",
            "discriminator": [
                14
            ],
            "accounts": [
                {
                    "name": "buyer",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "token_sy_trader",
                    "writable": true
                },
                {
                    "name": "token_pt_trader",
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "writable": true
                },
                {
                    "name": "address_lookup_table"
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "token_fee_treasury_sy",
                    "writable": true
                },
                {
                    "name": "token_fee_treasury_pt",
                    "writable": true
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "min_pt_amount",
                    "type": "u64"
                },
                {
                    "name": "base_amount",
                    "type": "u64"
                },
                {
                    "name": "price_spot_limit",
                    "type": {
                        "option": "f64"
                    }
                },
                {
                    "name": "mint_sy_rem_accounts_until",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "buy_yt",
            "discriminator": [
                12
            ],
            "accounts": [
                {
                    "name": "trader",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "token_sy_trader",
                    "docs": [
                        "Source account for the trader's SY tokens"
                    ],
                    "writable": true
                },
                {
                    "name": "token_yt_trader",
                    "docs": [
                        "Destination for receiving YT tokens"
                    ],
                    "writable": true
                },
                {
                    "name": "token_pt_trader",
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "docs": [
                        "Temporary SY account owned by market"
                    ],
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "docs": [
                        "PT liquidity owned by market"
                    ],
                    "writable": true
                },
                {
                    "name": "token_yt_escrow",
                    "docs": [
                        "YT liquidity account"
                    ],
                    "writable": true
                },
                {
                    "name": "token_fee_treasury_sy",
                    "writable": true
                },
                {
                    "name": "token_fee_treasury_pt",
                    "writable": true
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "address_lookup_table"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "exponent_core_program"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "sy_in",
                    "type": "u64"
                },
                {
                    "name": "min_yt_out",
                    "type": "u64"
                },
                {
                    "name": "price_spot_limit",
                    "type": {
                        "option": "f64"
                    }
                }
            ],
            "returns": {
                "defined": {
                    "name": "BuyYtEvent"
                }
            }
        },
        {
            "name": "claim_farm_emission",
            "discriminator": [
                6
            ],
            "accounts": [
                {
                    "name": "owner",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market"
                },
                {
                    "name": "ticks"
                },
                {
                    "name": "lp_position",
                    "writable": true
                },
                {
                    "name": "token_dst",
                    "writable": true
                },
                {
                    "name": "mint"
                },
                {
                    "name": "token_farm",
                    "writable": true
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "amount",
                    "type": {
                        "defined": {
                            "name": "Amount"
                        }
                    }
                }
            ],
            "returns": {
                "defined": {
                    "name": "ClaimFarmEmissionsEvent"
                }
            }
        },
        {
            "name": "deposit_liquidity",
            "discriminator": [
                4
            ],
            "accounts": [
                {
                    "name": "depositor",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "lp_position",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "token_pt_src",
                    "writable": true
                },
                {
                    "name": "token_sy_src",
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "writable": true
                },
                {
                    "name": "address_lookup_table",
                    "docs": [
                        "Address lookup table for vault"
                    ]
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "instructions_sysvar"
                },
                {
                    "name": "system_program"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "lower_tick_key",
                    "type": "u32"
                },
                {
                    "name": "upper_tick_key",
                    "type": "u32"
                },
                {
                    "name": "max_sy_in",
                    "type": "u64"
                },
                {
                    "name": "max_pt_in",
                    "type": "u64"
                }
            ],
            "returns": {
                "defined": {
                    "name": "DepositLiquidityReturnData"
                }
            }
        },
        {
            "name": "initialize_market",
            "docs": [
                "High-trust function to init market"
            ],
            "discriminator": [
                2
            ],
            "accounts": [
                {
                    "name": "payer",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "admin_signer",
                    "signer": true
                },
                {
                    "name": "admin_state"
                },
                {
                    "name": "lp_position",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "docs": [
                        "There is 1 market per vault"
                    ],
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "vault",
                    "docs": [
                        "Links the mint_sy & mint_pt & sy_program together"
                    ]
                },
                {
                    "name": "mint_sy"
                },
                {
                    "name": "mint_pt"
                },
                {
                    "name": "mint_yt"
                },
                {
                    "name": "escrow_pt",
                    "writable": true
                },
                {
                    "name": "escrow_sy",
                    "docs": [
                        "This account for SY is only a temporary pass-through account",
                        "It is used to transfer SY tokens from the signer to the market",
                        "And then from the market to the SY program's escrow"
                    ],
                    "writable": true
                },
                {
                    "name": "escrow_yt",
                    "docs": [
                        "This account for YT is only a temporary pass-through account",
                        "It is used to transfer YT tokens from the signer to the market",
                        "And then from the market to the core program's"
                    ],
                    "writable": true
                },
                {
                    "name": "pt_src",
                    "docs": [
                        "Signer's PT token account"
                    ],
                    "writable": true
                },
                {
                    "name": "sy_src",
                    "docs": [
                        "Signer's SY token account"
                    ],
                    "writable": true
                },
                {
                    "name": "token_program",
                    "docs": [
                        "Use Token2022 as the implementation for PT & SY & LP tokens"
                    ]
                },
                {
                    "name": "system_program"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "exponent_core",
                    "writable": true
                },
                {
                    "name": "associated_token_program"
                },
                {
                    "name": "address_lookup_table"
                },
                {
                    "name": "token_treasury_fee_sy"
                },
                {
                    "name": "token_treasury_fee_pt"
                },
                {
                    "name": "instructions_sysvar"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "ln_fee_rate_root",
                    "type": "f64"
                },
                {
                    "name": "pt_init",
                    "type": "u64"
                },
                {
                    "name": "sy_init",
                    "type": "u64"
                },
                {
                    "name": "fee_treasury_bps",
                    "type": "u16"
                },
                {
                    "name": "cpi_accounts",
                    "type": {
                        "defined": {
                            "name": "CpiAccounts"
                        }
                    }
                },
                {
                    "name": "cpi_core_accounts",
                    "type": {
                        "defined": {
                            "name": "CpiCoreAccounts"
                        }
                    }
                },
                {
                    "name": "min_lp_tick_amount",
                    "type": "u64"
                },
                {
                    "name": "epsilon_clamp",
                    "type": "f64"
                },
                {
                    "name": "max_lp_supply",
                    "type": "u64"
                },
                {
                    "name": "current_price_apy",
                    "type": "u32"
                },
                {
                    "name": "tick_space",
                    "type": "u32"
                },
                {
                    "name": "lower_tick_key",
                    "type": "u32"
                },
                {
                    "name": "upper_tick_key",
                    "type": "u32"
                },
                {
                    "name": "seed_id",
                    "type": "u8"
                }
            ],
            "returns": {
                "defined": {
                    "name": "MarketThreeInitEvent"
                }
            }
        },
        {
            "name": "market_accrue_emission",
            "discriminator": [
                23
            ],
            "accounts": [
                {
                    "name": "owner",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "lp_position",
                    "writable": true
                },
                {
                    "name": "address_lookup_table"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "system_program"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [],
            "returns": {
                "defined": {
                    "name": "MarketAccrueEmissionEvent"
                }
            }
        },
        {
            "name": "market_collect_emission",
            "discriminator": [
                11
            ],
            "accounts": [
                {
                    "name": "owner",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "lp_position",
                    "writable": true
                },
                {
                    "name": "token_emission_escrow",
                    "writable": true
                },
                {
                    "name": "token_emission_dst",
                    "writable": true
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "address_lookup_table"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "emission_index",
                    "type": "u16"
                }
            ],
            "returns": {
                "defined": {
                    "name": "MarketCollectEmissionEvent"
                }
            }
        },
        {
            "name": "modify_farm",
            "discriminator": [
                9
            ],
            "accounts": [
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "signer",
                    "signer": true
                },
                {
                    "name": "mint"
                },
                {
                    "name": "token_source",
                    "writable": true
                },
                {
                    "name": "token_farm",
                    "writable": true
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "new_expiration_timestamp",
                    "type": "u32"
                },
                {
                    "name": "new_rate",
                    "type": "u64"
                }
            ],
            "returns": {
                "defined": {
                    "name": "ModifyFarmEvent"
                }
            }
        },
        {
            "name": "modify_market_setting",
            "discriminator": [
                10
            ],
            "accounts": [
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "signer",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "admin_state"
                },
                {
                    "name": "system_program"
                }
            ],
            "args": [
                {
                    "name": "action",
                    "type": {
                        "defined": {
                            "name": "MarketAdminAction"
                        }
                    }
                }
            ]
        },
        {
            "name": "sell_pt",
            "discriminator": [
                15
            ],
            "accounts": [
                {
                    "name": "seller",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "token_sy_trader",
                    "writable": true
                },
                {
                    "name": "token_pt_trader",
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "writable": true
                },
                {
                    "name": "address_lookup_table"
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "token_fee_treasury_sy",
                    "writable": true
                },
                {
                    "name": "token_fee_treasury_pt",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "amount_pt",
                    "type": "u64"
                },
                {
                    "name": "min_base_amount",
                    "type": "u64"
                },
                {
                    "name": "price_spot_limit",
                    "type": {
                        "option": "f64"
                    }
                },
                {
                    "name": "redeem_sy_rem_accounts_until",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "sell_yt",
            "discriminator": [
                13
            ],
            "accounts": [
                {
                    "name": "trader",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "token_yt_trader",
                    "writable": true
                },
                {
                    "name": "token_pt_trader",
                    "writable": true
                },
                {
                    "name": "token_sy_trader",
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "docs": [
                        "Account owned by market",
                        "This is a temporary account that receives SY tokens from the user, after which it transfers them to the SY program"
                    ],
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "docs": [
                        "PT liquidity account"
                    ],
                    "writable": true
                },
                {
                    "name": "token_yt_escrow",
                    "docs": [
                        "YT liquidity account"
                    ],
                    "writable": true
                },
                {
                    "name": "address_lookup_table"
                },
                {
                    "name": "token_fee_treasury_sy",
                    "writable": true
                },
                {
                    "name": "token_fee_treasury_pt",
                    "writable": true
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "exponent_core_program"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "yt_in",
                    "type": "u64"
                },
                {
                    "name": "min_sy_out",
                    "type": "u64"
                },
                {
                    "name": "price_spot_limit",
                    "type": {
                        "option": "f64"
                    }
                }
            ],
            "returns": {
                "defined": {
                    "name": "SellYtEvent"
                }
            }
        },
        {
            "name": "trade_pt",
            "discriminator": [
                3
            ],
            "accounts": [
                {
                    "name": "trader",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "token_sy_trader",
                    "docs": [
                        "Trader's SY token account",
                        "Mint is constrained by TokenProgram"
                    ],
                    "writable": true
                },
                {
                    "name": "token_pt_trader",
                    "docs": [
                        "Receiving PT token account",
                        "Mint is constrained by TokenProgram"
                    ],
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "docs": [
                        "Account owned by market",
                        "This is a temporary account that receives SY tokens from the user, after which it transfers them to the SY program"
                    ],
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "docs": [
                        "PT liquidity account"
                    ],
                    "writable": true
                },
                {
                    "name": "address_lookup_table"
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "token_fee_treasury_sy",
                    "writable": true
                },
                {
                    "name": "token_fee_treasury_pt",
                    "writable": true
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "amount_in",
                    "type": "u64"
                },
                {
                    "name": "swap_direction",
                    "type": {
                        "defined": {
                            "name": "SwapDirection"
                        }
                    }
                },
                {
                    "name": "amount_out_constraint",
                    "type": {
                        "option": "u64"
                    }
                },
                {
                    "name": "price_spot_limit",
                    "type": {
                        "option": "f64"
                    }
                }
            ],
            "returns": {
                "defined": {
                    "name": "TradePtEvent"
                }
            }
        },
        {
            "name": "trade_pt_exact_out",
            "discriminator": [
                24
            ],
            "accounts": [
                {
                    "name": "trader",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "token_sy_trader",
                    "docs": [
                        "Trader's SY token account",
                        "Mint is constrained by TokenProgram"
                    ],
                    "writable": true
                },
                {
                    "name": "token_pt_trader",
                    "docs": [
                        "Receiving PT token account",
                        "Mint is constrained by TokenProgram"
                    ],
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "docs": [
                        "Account owned by market",
                        "This is a temporary account that receives SY tokens from the user, after which it transfers them to the SY program"
                    ],
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "docs": [
                        "PT liquidity account"
                    ],
                    "writable": true
                },
                {
                    "name": "address_lookup_table"
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "token_fee_treasury_sy",
                    "writable": true
                },
                {
                    "name": "token_fee_treasury_pt",
                    "writable": true
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "amount_out",
                    "type": "u64"
                },
                {
                    "name": "swap_direction",
                    "type": {
                        "defined": {
                            "name": "SwapDirection"
                        }
                    }
                },
                {
                    "name": "amount_in_constraint",
                    "type": {
                        "option": "u64"
                    }
                },
                {
                    "name": "price_spot_limit",
                    "type": {
                        "option": "f64"
                    }
                }
            ],
            "returns": {
                "defined": {
                    "name": "TradePtEvent"
                }
            }
        },
        {
            "name": "withdraw_liquidity",
            "discriminator": [
                5
            ],
            "accounts": [
                {
                    "name": "owner",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "lp_position",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "token_pt_dst",
                    "writable": true
                },
                {
                    "name": "token_sy_dst",
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "docs": [
                        "Market PT liquidity account"
                    ],
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "docs": [
                        "Market-owned interchange account for SY"
                    ],
                    "writable": true
                },
                {
                    "name": "address_lookup_table",
                    "docs": [
                        "Address lookup table for vault"
                    ]
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "system_program"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "liquidity_to_remove",
                    "type": "u64"
                },
                {
                    "name": "min_pt_out",
                    "type": "u64"
                },
                {
                    "name": "min_sy_out",
                    "type": "u64"
                }
            ],
            "returns": {
                "defined": {
                    "name": "WithdrawLiquidityReturnData"
                }
            }
        },
        {
            "name": "wrapper_buy_yt",
            "discriminator": [
                16
            ],
            "accounts": [
                {
                    "name": "buyer",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "token_sy_trader",
                    "writable": true
                },
                {
                    "name": "token_yt_trader",
                    "writable": true
                },
                {
                    "name": "token_pt_trader",
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "writable": true
                },
                {
                    "name": "token_yt_escrow",
                    "writable": true
                },
                {
                    "name": "market_address_lookup_table"
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "system_program"
                },
                {
                    "name": "token_fee_treasury_sy",
                    "writable": true
                },
                {
                    "name": "token_fee_treasury_pt",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "exponent_core_program"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "yt_out",
                    "type": "u64"
                },
                {
                    "name": "max_base_amount",
                    "type": "u64"
                },
                {
                    "name": "mint_sy_accounts_length",
                    "type": "u8"
                },
                {
                    "name": "deposit_yt_accounts_until",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "wrapper_provide_liquidity",
            "discriminator": [
                18
            ],
            "accounts": [
                {
                    "name": "depositor",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "docs": [
                        "PT liquidity account"
                    ],
                    "writable": true
                },
                {
                    "name": "token_yt_escrow",
                    "docs": [
                        "YT liquidity account"
                    ],
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "docs": [
                        "SY token account owned by the market"
                    ],
                    "writable": true
                },
                {
                    "name": "token_sy_depositor",
                    "docs": [
                        "Token account for SY owned by the depositor"
                    ],
                    "writable": true
                },
                {
                    "name": "token_yt_depositor",
                    "docs": [
                        "Token account for YT owned by the depositor"
                    ],
                    "writable": true
                },
                {
                    "name": "token_pt_depositor",
                    "docs": [
                        "Token account for PT owned by the depositor"
                    ],
                    "writable": true
                },
                {
                    "name": "mint_yt",
                    "writable": true
                },
                {
                    "name": "mint_pt",
                    "writable": true
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "market_address_lookup_table"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "exponent_core_program"
                },
                {
                    "name": "lp_position",
                    "writable": true
                },
                {
                    "name": "instructions_sysvar"
                },
                {
                    "name": "system_program"
                },
                {
                    "name": "rent"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "lower_tick",
                    "type": "u32"
                },
                {
                    "name": "upper_tick",
                    "type": "u32"
                },
                {
                    "name": "amount_base",
                    "type": "u64"
                },
                {
                    "name": "min_lp_out",
                    "type": "u64"
                },
                {
                    "name": "mint_sy_rem_accounts_until",
                    "type": "u8"
                },
                {
                    "name": "deposit_yt_accounts_until",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "wrapper_provide_liquidity_base",
            "discriminator": [
                26
            ],
            "accounts": [
                {
                    "name": "depositor",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "docs": [
                        "PT liquidity account"
                    ],
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "docs": [
                        "SY token account owned by the market"
                    ],
                    "writable": true
                },
                {
                    "name": "token_sy_depositor",
                    "docs": [
                        "Token account for SY owned by the depositor"
                    ],
                    "writable": true
                },
                {
                    "name": "token_pt_depositor",
                    "docs": [
                        "Token account for PT owned by the depositor"
                    ],
                    "writable": true
                },
                {
                    "name": "token_fee_treasury_sy",
                    "writable": true
                },
                {
                    "name": "token_fee_treasury_pt",
                    "writable": true
                },
                {
                    "name": "mint_pt",
                    "writable": true
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "market_address_lookup_table"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "exponent_core_program"
                },
                {
                    "name": "lp_position",
                    "writable": true
                },
                {
                    "name": "instructions_sysvar"
                },
                {
                    "name": "system_program"
                },
                {
                    "name": "rent"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "lower_tick_key",
                    "type": "u32"
                },
                {
                    "name": "upper_tick_key",
                    "type": "u32"
                },
                {
                    "name": "min_lp_out",
                    "type": "u64"
                },
                {
                    "name": "mint_sy_accounts_until",
                    "type": "u8"
                },
                {
                    "name": "external_pt_to_buy",
                    "type": "u64"
                },
                {
                    "name": "external_sy_constraint",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "wrapper_provide_liquidity_classic",
            "discriminator": [
                19
            ],
            "accounts": [
                {
                    "name": "depositor",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "docs": [
                        "PT liquidity account"
                    ],
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "docs": [
                        "SY token account owned by the market"
                    ],
                    "writable": true
                },
                {
                    "name": "token_sy_depositor",
                    "docs": [
                        "Token account for SY owned by the depositor"
                    ],
                    "writable": true
                },
                {
                    "name": "token_pt_depositor",
                    "docs": [
                        "Token account for PT owned by the depositor"
                    ],
                    "writable": true
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "market_address_lookup_table"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "lp_position",
                    "writable": true
                },
                {
                    "name": "instructions_sysvar"
                },
                {
                    "name": "system_program"
                },
                {
                    "name": "rent"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "lower_tick",
                    "type": "u32"
                },
                {
                    "name": "upper_tick",
                    "type": "u32"
                },
                {
                    "name": "amount_base",
                    "type": "u64"
                },
                {
                    "name": "amount_pt",
                    "type": "u64"
                },
                {
                    "name": "min_lp_out",
                    "type": "u64"
                },
                {
                    "name": "mint_sy_accounts_until",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "wrapper_sell_yt",
            "discriminator": [
                17
            ],
            "accounts": [
                {
                    "name": "seller",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "token_sy_trader",
                    "writable": true
                },
                {
                    "name": "token_yt_trader",
                    "writable": true
                },
                {
                    "name": "token_pt_trader",
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "writable": true
                },
                {
                    "name": "token_yt_escrow",
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "writable": true
                },
                {
                    "name": "market_address_lookup_table"
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "token_fee_treasury_sy",
                    "writable": true
                },
                {
                    "name": "token_fee_treasury_pt",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "exponent_core_program"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "yt_amount",
                    "type": "u64"
                },
                {
                    "name": "min_base_amount",
                    "type": "u64"
                },
                {
                    "name": "redeem_sy_accounts_until",
                    "type": "u8"
                },
                {
                    "name": "withdraw_yt_accounts_until",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "wrapper_withdraw_liquidity",
            "discriminator": [
                20
            ],
            "accounts": [
                {
                    "name": "withdrawer",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "docs": [
                        "PT liquidity account"
                    ],
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "docs": [
                        "SY token account owned by the market"
                    ],
                    "writable": true
                },
                {
                    "name": "token_sy_withdrawer",
                    "docs": [
                        "Token account for SY owned by the depositor"
                    ],
                    "writable": true
                },
                {
                    "name": "token_pt_withdrawer",
                    "docs": [
                        "Token account for PT owned by the depositor"
                    ],
                    "writable": true
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "market_address_lookup_table"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "token_fee_treasury_sy",
                    "writable": true
                },
                {
                    "name": "token_fee_treasury_pt",
                    "writable": true
                },
                {
                    "name": "lp_position",
                    "writable": true
                },
                {
                    "name": "system_program"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "amount_lp",
                    "type": "u64"
                },
                {
                    "name": "sy_constraint",
                    "type": "u64"
                },
                {
                    "name": "redeem_sy_accounts_length",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "wrapper_withdraw_liquidity_classic",
            "discriminator": [
                21
            ],
            "accounts": [
                {
                    "name": "withdrawer",
                    "writable": true,
                    "signer": true
                },
                {
                    "name": "market",
                    "writable": true
                },
                {
                    "name": "ticks",
                    "writable": true
                },
                {
                    "name": "token_pt_escrow",
                    "docs": [
                        "PT liquidity account"
                    ],
                    "writable": true
                },
                {
                    "name": "token_sy_escrow",
                    "docs": [
                        "SY token account owned by the market"
                    ],
                    "writable": true
                },
                {
                    "name": "token_sy_withdrawer",
                    "docs": [
                        "Token account for SY owned by the depositor"
                    ],
                    "writable": true
                },
                {
                    "name": "token_pt_withdrawer",
                    "docs": [
                        "Token account for PT owned by the depositor"
                    ],
                    "writable": true
                },
                {
                    "name": "token_program"
                },
                {
                    "name": "market_address_lookup_table"
                },
                {
                    "name": "sy_program"
                },
                {
                    "name": "lp_position",
                    "writable": true
                },
                {
                    "name": "system_program"
                },
                {
                    "name": "event_authority"
                },
                {
                    "name": "program"
                }
            ],
            "args": [
                {
                    "name": "amount_lp",
                    "type": "u64"
                },
                {
                    "name": "redeem_sy_accounts_length",
                    "type": "u8"
                }
            ]
        }
    ],
    "accounts": [
        {
            "name": "Admin",
            "discriminator": [
                244,
                158,
                220,
                65,
                8,
                73,
                4,
                65
            ]
        },
        {
            "name": "LpPosition",
            "discriminator": [
                105,
                241,
                37,
                200,
                224,
                2,
                252,
                90
            ]
        },
        {
            "name": "MarketThree",
            "discriminator": [
                242,
                240,
                26,
                15,
                148,
                186,
                185,
                205
            ]
        },
        {
            "name": "Vault",
            "discriminator": [
                211,
                8,
                232,
                43,
                2,
                152,
                117,
                119
            ]
        }
    ],
    "events": [
        {
            "name": "AddFarmEvent",
            "discriminator": [
                128,
                69,
                228,
                140,
                211,
                1,
                236,
                209
            ]
        },
        {
            "name": "BuyPtEvent",
            "discriminator": [
                62,
                132,
                50,
                43,
                219,
                234,
                221,
                167
            ]
        },
        {
            "name": "BuyYtEvent",
            "discriminator": [
                172,
                181,
                56,
                183,
                219,
                24,
                130,
                64
            ]
        },
        {
            "name": "ClaimFarmEmissionsEvent",
            "discriminator": [
                184,
                10,
                159,
                144,
                144,
                194,
                166,
                92
            ]
        },
        {
            "name": "DepositLiquidityEvent",
            "discriminator": [
                169,
                84,
                67,
                174,
                222,
                138,
                16,
                123
            ]
        },
        {
            "name": "DepositLiquidityReturnData",
            "discriminator": [
                251,
                222,
                183,
                16,
                43,
                40,
                133,
                193
            ]
        },
        {
            "name": "MarketAccrueEmissionEvent",
            "discriminator": [
                62,
                90,
                81,
                179,
                105,
                110,
                108,
                49
            ]
        },
        {
            "name": "MarketCollectEmissionEvent",
            "discriminator": [
                125,
                129,
                15,
                139,
                232,
                244,
                82,
                67
            ]
        },
        {
            "name": "MarketThreeInitEvent",
            "discriminator": [
                247,
                116,
                192,
                184,
                106,
                246,
                165,
                183
            ]
        },
        {
            "name": "MergeEvent",
            "discriminator": [
                25,
                30,
                29,
                41,
                108,
                139,
                103,
                4
            ]
        },
        {
            "name": "ModifyFarmEvent",
            "discriminator": [
                140,
                186,
                92,
                18,
                4,
                227,
                22,
                14
            ]
        },
        {
            "name": "SellPtEvent",
            "discriminator": [
                103,
                139,
                188,
                216,
                68,
                124,
                110,
                63
            ]
        },
        {
            "name": "SellYtEvent",
            "discriminator": [
                149,
                147,
                29,
                159,
                148,
                240,
                129,
                7
            ]
        },
        {
            "name": "StripEvent",
            "discriminator": [
                114,
                189,
                26,
                143,
                143,
                50,
                197,
                89
            ]
        },
        {
            "name": "TradePtEvent",
            "discriminator": [
                159,
                225,
                96,
                81,
                255,
                227,
                233,
                174
            ]
        },
        {
            "name": "WithdrawLiquidityEvent",
            "discriminator": [
                214,
                6,
                161,
                45,
                191,
                142,
                124,
                186
            ]
        },
        {
            "name": "WithdrawLiquidityReturnData",
            "discriminator": [
                42,
                97,
                75,
                157,
                90,
                121,
                189,
                110
            ]
        },
        {
            "name": "WrapperBuyYtEvent",
            "discriminator": [
                148,
                95,
                21,
                54,
                99,
                16,
                15,
                40
            ]
        },
        {
            "name": "WrapperProvideLiquidityBaseEvent",
            "discriminator": [
                60,
                121,
                164,
                93,
                220,
                13,
                142,
                197
            ]
        },
        {
            "name": "WrapperProvideLiquidityClassicEvent",
            "discriminator": [
                87,
                163,
                150,
                162,
                186,
                147,
                234,
                200
            ]
        },
        {
            "name": "WrapperProvideLiquidityEvent",
            "discriminator": [
                209,
                42,
                227,
                77,
                187,
                216,
                17,
                177
            ]
        },
        {
            "name": "WrapperSellYtEvent",
            "discriminator": [
                252,
                140,
                45,
                253,
                6,
                94,
                95,
                135
            ]
        },
        {
            "name": "WrapperWithdrawLiquidityClassicEvent",
            "discriminator": [
                18,
                154,
                212,
                39,
                36,
                23,
                158,
                124
            ]
        },
        {
            "name": "WrapperWithdrawLiquidityEvent",
            "discriminator": [
                52,
                32,
                180,
                241,
                36,
                221,
                72,
                167
            ]
        }
    ],
    "errors": [
        {
            "code": 6000,
            "name": "VaultExpired",
            "msg": "Vault is expired"
        },
        {
            "code": 6001,
            "name": "DeltaLZero",
            "msg": "Delta liquidity can't be zero"
        },
        {
            "code": 6002,
            "name": "TickArrayAlreadyBoundToMarket",
            "msg": "Tick array already bound to market"
        },
        {
            "code": 6003,
            "name": "LiquidityUnderflow",
            "msg": "LiquidityUnderflow"
        },
        {
            "code": 6004,
            "name": "LiquidityOverflow",
            "msg": "LiquidityOverflow"
        },
        {
            "code": 6005,
            "name": "PriceLimitViolated",
            "msg": "Price limit violated"
        },
        {
            "code": 6006,
            "name": "EndOfRange",
            "msg": "End of range"
        },
        {
            "code": 6007,
            "name": "Unauthorized",
            "msg": "Unauthorized"
        },
        {
            "code": 6008,
            "name": "InsufficientBudgetSY",
            "msg": "Insufficient budget SY"
        },
        {
            "code": 6009,
            "name": "InsufficientBudgetPT",
            "msg": "Insufficient budget PT"
        },
        {
            "code": 6010,
            "name": "IntervalNotFound",
            "msg": "Interval not found"
        },
        {
            "code": 6011,
            "name": "LpSupplyMaximumExceeded",
            "msg": "lp supply maximum exceeded"
        },
        {
            "code": 6012,
            "name": "DepositingLiquidityDisabled",
            "msg": "Depositing liquidity disabled"
        },
        {
            "code": 6013,
            "name": "BuyingPtDisabled",
            "msg": "Buying pt disabled"
        },
        {
            "code": 6014,
            "name": "SellingPtDisabled",
            "msg": "Selling pt disabled"
        },
        {
            "code": 6015,
            "name": "WithdrawingLiquidityDisabled",
            "msg": "Withdrawing liquidity disabled"
        },
        {
            "code": 6016,
            "name": "BuyingYtDisabled",
            "msg": "Buying YT is disabled"
        },
        {
            "code": 6017,
            "name": "SellingYtDisabled",
            "msg": "Selling YT is disabled"
        },
        {
            "code": 6018,
            "name": "NoRightIndexForSplitedRange",
            "msg": "No right index for splitted range"
        },
        {
            "code": 6019,
            "name": "ExactOutDirectionUnsupported",
            "msg": "Exact-out swaps are unsupported for this direction"
        },
        {
            "code": 6020,
            "name": "WithdrawalAccountingDustExceeded",
            "msg": "Withdrawal accounting dust exceeded limit"
        },
        {
            "code": 6021,
            "name": "InvalidExpirationTimestamp",
            "msg": "Invalid expiration timestamp"
        },
        {
            "code": 6022,
            "name": "YieldTrackerLimitExceeded",
            "msg": "Tracker limit exceeded"
        },
        {
            "code": 6023,
            "name": "InvalidTickRange",
            "msg": "Lower and upper tick must differ"
        },
        {
            "code": 6024,
            "name": "TickRangeTooSmall",
            "msg": "Tick range width below epsilon clamp"
        },
        {
            "code": 6025,
            "name": "LpMinNotReached",
            "msg": "Lp min not reached"
        },
        {
            "code": 6026,
            "name": "EmissionsTrackerLengthMismatch",
            "msg": "Emissions tracker length mismatch"
        },
        {
            "code": 6027,
            "name": "LiquidityToRemoveExceedsBalance",
            "msg": "Liquidity to remove exceeds position balance"
        },
        {
            "code": 6028,
            "name": "InvalidFeeRate",
            "msg": "Fee rate configuration must not exceed 5% annualized"
        },
        {
            "code": 6029,
            "name": "IntegerOverflow",
            "msg": "Integer overflow during conversion"
        },
        {
            "code": 6030,
            "name": "InvalidAccountData",
            "msg": "Invalid account data"
        },
        {
            "code": 6031,
            "name": "ConstraintViolation",
            "msg": "Account constraint violation"
        },
        {
            "code": 6032,
            "name": "DepositTooSmallToMint",
            "msg": "Deposit amount too small to mint shares"
        },
        {
            "code": 6033,
            "name": "TickNotAlignedToTickSpace",
            "msg": "Tick key must be a multiple of tick_space"
        },
        {
            "code": 6034,
            "name": "AddingLiquidityCurrentlyNotAllowed",
            "msg": "Adding liquidity currently is not allowed"
        },
        {
            "code": 6035,
            "name": "CrossingEqualizationInvariantViolated",
            "msg": "Crossing equalization invariants were violated"
        }
    ],
    "types": [
        {
            "name": "AddFarmEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "admin_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "farm_index",
                        "type": "u16"
                    },
                    {
                        "name": "emission_mint",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_rate",
                        "type": "u64"
                    },
                    {
                        "name": "expiry_timestamp",
                        "type": "u32"
                    },
                    {
                        "name": "amount_deposited",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "Admin",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "uber_admin",
                        "type": "pubkey"
                    },
                    {
                        "name": "proposed_uber_admin",
                        "type": {
                            "option": "pubkey"
                        }
                    },
                    {
                        "name": "principles",
                        "type": {
                            "defined": {
                                "name": "Principles"
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "Amount",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "All"
                    },
                    {
                        "name": "Some",
                        "fields": [
                            "u64"
                        ]
                    }
                ]
            }
        },
        {
            "name": "BuyPtEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "buyer_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "amount_base_in",
                        "type": "u64"
                    },
                    {
                        "name": "amount_pt_out",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "BuyYtEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "trader_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_sy_trader",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_yt_trader",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_pt_trader",
                        "type": "pubkey"
                    },
                    {
                        "name": "max_sy_in",
                        "type": "u64"
                    },
                    {
                        "name": "amount_yt_out",
                        "type": "u64"
                    },
                    {
                        "name": "sy_exchange_rate",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "amount_sy_to_strip",
                        "type": "u64"
                    },
                    {
                        "name": "amount_sy_borrowed",
                        "type": "u64"
                    },
                    {
                        "name": "amount_pt_out",
                        "type": "u64"
                    },
                    {
                        "name": "amount_sy_repaid",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "ClaimFarmEmissionsEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "owner_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "lp_position",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_owner",
                        "type": "pubkey"
                    },
                    {
                        "name": "mint",
                        "type": "pubkey"
                    },
                    {
                        "name": "farm_index",
                        "type": "u8"
                    },
                    {
                        "name": "amount_claimed",
                        "type": "u64"
                    },
                    {
                        "name": "remaining_staged",
                        "type": "u64"
                    },
                    {
                        "name": "lp_balance",
                        "type": "u64"
                    },
                    {
                        "name": "lower_tick",
                        "type": "u32"
                    },
                    {
                        "name": "upper_tick",
                        "type": "u32"
                    },
                    {
                        "name": "tokens_owed_sy",
                        "type": "u64"
                    },
                    {
                        "name": "tokens_owed_pt",
                        "type": "u64"
                    },
                    {
                        "name": "farms",
                        "type": {
                            "defined": {
                                "name": "PersonalYieldTrackers"
                            }
                        }
                    },
                    {
                        "name": "share_trackers",
                        "type": {
                            "defined": {
                                "name": "PrincipalShareTrackers"
                            }
                        }
                    },
                    {
                        "name": "fee_inside_last_pt",
                        "type": "u128"
                    },
                    {
                        "name": "fee_inside_last_sy",
                        "type": "u128"
                    }
                ]
            }
        },
        {
            "name": "ClaimLimits",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "claim_window_start_timestamp",
                        "type": "u32"
                    },
                    {
                        "name": "total_claim_amount_in_window",
                        "type": "u64"
                    },
                    {
                        "name": "max_claim_amount_per_window",
                        "type": "u64"
                    },
                    {
                        "name": "claim_window_duration_seconds",
                        "type": "u32"
                    }
                ]
            }
        },
        {
            "name": "ConfigurationOptions",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "ln_fee_rate_root",
                        "docs": [
                            "Initial log of fee rate, which decreases over time"
                        ],
                        "type": "f64"
                    },
                    {
                        "name": "treasury_fee_bps",
                        "docs": [
                            "Protocol fee cut BPS"
                        ],
                        "type": "u16"
                    },
                    {
                        "name": "min_lp_tick_amount",
                        "docs": [
                            "Minimum amount of LP tokens to be issued"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "epsilon_clamp",
                        "docs": [
                            "min denomination for reinvest liquidity"
                        ],
                        "type": "f64"
                    },
                    {
                        "name": "max_lp_supply",
                        "type": "u64"
                    },
                    {
                        "name": "tick_space",
                        "type": "u32"
                    },
                    {
                        "name": "_reserved",
                        "type": {
                            "array": [
                                "u8",
                                1024
                            ]
                        }
                    }
                ]
            }
        },
        {
            "name": "CpiAccounts",
            "docs": [
                "Account lists for validating CPI calls to the SY program"
            ],
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "get_sy_state",
                        "docs": [
                            "Fetch SY state"
                        ],
                        "type": {
                            "vec": {
                                "defined": {
                                    "name": "CpiInterfaceContext"
                                }
                            }
                        }
                    },
                    {
                        "name": "deposit_sy",
                        "docs": [
                            "Deposit SY into personal account owned by vault"
                        ],
                        "type": {
                            "vec": {
                                "defined": {
                                    "name": "CpiInterfaceContext"
                                }
                            }
                        }
                    },
                    {
                        "name": "withdraw_sy",
                        "docs": [
                            "Withdraw SY from personal account owned by vault"
                        ],
                        "type": {
                            "vec": {
                                "defined": {
                                    "name": "CpiInterfaceContext"
                                }
                            }
                        }
                    },
                    {
                        "name": "claim_emission",
                        "docs": [
                            "Settle rewards for vault to accounts owned by the vault"
                        ],
                        "type": {
                            "vec": {
                                "vec": {
                                    "defined": {
                                        "name": "CpiInterfaceContext"
                                    }
                                }
                            }
                        }
                    },
                    {
                        "name": "get_position_state",
                        "docs": [
                            "Get personal yield position"
                        ],
                        "type": {
                            "vec": {
                                "defined": {
                                    "name": "CpiInterfaceContext"
                                }
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "CpiCoreAccounts",
            "docs": [
                "Account lists for validating CPI calls to the SY program"
            ],
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "strip_sy",
                        "docs": [
                            "Strip sy"
                        ],
                        "type": {
                            "vec": {
                                "defined": {
                                    "name": "CpiInterfaceContext"
                                }
                            }
                        }
                    },
                    {
                        "name": "merge_sy",
                        "docs": [
                            "Merge sy"
                        ],
                        "type": {
                            "vec": {
                                "defined": {
                                    "name": "CpiInterfaceContext"
                                }
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "CpiInterfaceContext",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "alt_index",
                        "docs": [
                            "Address-lookup-table index"
                        ],
                        "type": "u8"
                    },
                    {
                        "name": "is_signer",
                        "type": "bool"
                    },
                    {
                        "name": "is_writable",
                        "type": "bool"
                    }
                ]
            }
        },
        {
            "name": "CrossingSplit",
            "docs": [
                "Represents the three virtual segments when a position spans the active tick.",
                "This allows tracking different liquidity (L_actual vs L_target) in the crossing segment."
            ],
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "cross_left_idx",
                        "docs": [
                            "Left boundary of the crossing tick (current_tick at deposit time)"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "cross_right_idx",
                        "docs": [
                            "Right boundary of the crossing tick"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "lp_balance_crossing",
                        "docs": [
                            "Actual liquidity for the crossing segment (L_actual, may be < L_target)"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "fee_inside_last_a_pt",
                        "type": "u128"
                    },
                    {
                        "name": "fee_inside_last_a_sy",
                        "type": "u128"
                    },
                    {
                        "name": "fee_inside_last_b_pt",
                        "type": "u128"
                    },
                    {
                        "name": "fee_inside_last_b_sy",
                        "type": "u128"
                    },
                    {
                        "name": "fee_inside_last_c_pt",
                        "type": "u128"
                    },
                    {
                        "name": "fee_inside_last_c_sy",
                        "type": "u128"
                    },
                    {
                        "name": "farms_a",
                        "type": {
                            "defined": {
                                "name": "PersonalYieldTrackers"
                            }
                        }
                    },
                    {
                        "name": "farms_b",
                        "type": {
                            "defined": {
                                "name": "PersonalYieldTrackers"
                            }
                        }
                    },
                    {
                        "name": "farms_c",
                        "type": {
                            "defined": {
                                "name": "PersonalYieldTrackers"
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "DepositLiquidityEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "depositor_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_pt_src",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_sy_src",
                        "type": "pubkey"
                    },
                    {
                        "name": "amount_pt_in",
                        "docs": [
                            "Total PT amount added (distributed across ticks in range)"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "amount_sy_in",
                        "docs": [
                            "Total SY amount added (distributed across ticks in range)"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "delta_liquidity",
                        "docs": [
                            "Liquidity added to the position"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "lower_tick",
                        "docs": [
                            "Lower tick boundary of the position"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "upper_tick",
                        "docs": [
                            "Upper tick boundary of the position"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "lp_position",
                        "docs": [
                            "LP position account address"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "lp_balance_after",
                        "docs": [
                            "Total LP balance after this deposit"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "tokens_owed_sy",
                        "docs": [
                            "Accumulated unclaimed SY fees"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "tokens_owed_pt",
                        "docs": [
                            "Accumulated unclaimed PT fees"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "farms",
                        "type": {
                            "defined": {
                                "name": "PersonalYieldTrackers"
                            }
                        }
                    },
                    {
                        "name": "share_trackers",
                        "type": {
                            "defined": {
                                "name": "PrincipalShareTrackers"
                            }
                        }
                    },
                    {
                        "name": "fee_inside_last_pt",
                        "docs": [
                            "Last snapshot of inside PT fee growth"
                        ],
                        "type": "u128"
                    },
                    {
                        "name": "fee_inside_last_sy",
                        "docs": [
                            "Last snapshot of inside SY fee growth"
                        ],
                        "type": "u128"
                    }
                ]
            }
        },
        {
            "name": "DepositLiquidityReturnData",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "depositor_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_pt_src",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_sy_src",
                        "type": "pubkey"
                    },
                    {
                        "name": "amount_pt_in",
                        "docs": [
                            "Total PT amount added (distributed across ticks in range)"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "amount_sy_in",
                        "docs": [
                            "Total SY amount added (distributed across ticks in range)"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "delta_liquidity",
                        "docs": [
                            "Liquidity added to the position"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "lower_tick",
                        "docs": [
                            "Lower tick boundary of the position"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "upper_tick",
                        "docs": [
                            "Upper tick boundary of the position"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "lp_position",
                        "docs": [
                            "LP position account address"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "lp_balance_after",
                        "docs": [
                            "Total LP balance after this deposit"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "tokens_owed_sy",
                        "docs": [
                            "Accumulated unclaimed SY fees"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "tokens_owed_pt",
                        "docs": [
                            "Accumulated unclaimed PT fees"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "fee_inside_last_pt",
                        "docs": [
                            "Last snapshot of inside PT fee growth"
                        ],
                        "type": "u128"
                    },
                    {
                        "name": "fee_inside_last_sy",
                        "docs": [
                            "Last snapshot of inside SY fee growth"
                        ],
                        "type": "u128"
                    }
                ]
            }
        },
        {
            "name": "EmissionInfo",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "token_account",
                        "docs": [
                            "The token account for the emission where the vault authority is the authority"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "initial_index",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "last_seen_index",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "final_index",
                        "docs": [
                            "The final index is used to track the last claimable index after the vault expires"
                        ],
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "treasury_token_account",
                        "docs": [
                            "The treasury token account for this reward"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "fee_bps",
                        "docs": [
                            "The fee taken from emission collecting"
                        ],
                        "type": "u16"
                    },
                    {
                        "name": "treasury_emission",
                        "docs": [
                            "The lambo fund"
                        ],
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "FarmEmission",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "mint",
                        "docs": [
                            "Mint for the emission token"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "token_rate",
                        "docs": [
                            "Rate at which the emission token is emitted per second"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "expiry_timestamp",
                        "docs": [
                            "Expiration timestamp for the emission token"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "index",
                        "docs": [
                            "Index for converting LP shares into earned emissions"
                        ],
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "LiquidityNetBalanceLimits",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "window_start_timestamp",
                        "type": "u32"
                    },
                    {
                        "name": "window_start_net_balance",
                        "type": "u64"
                    },
                    {
                        "name": "max_net_balance_change_negative_percentage",
                        "docs": [
                            "Maximum allowed negative change in basis points (10000 = 100%)"
                        ],
                        "type": "u16"
                    },
                    {
                        "name": "max_net_balance_change_positive_percentage",
                        "docs": [
                            "Maximum allowed positive change in basis points (10000 = 100%)",
                            "Using u32 to allow for very large increases (up to ~429,496%)"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "window_duration_seconds",
                        "type": "u32"
                    }
                ]
            }
        },
        {
            "name": "LpFarm",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "last_seen_timestamp",
                        "type": "u32"
                    },
                    {
                        "name": "farm_emissions",
                        "type": {
                            "vec": {
                                "defined": {
                                    "name": "FarmEmission"
                                }
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "LpPosition",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "owner",
                        "docs": [
                            "Link to address that owns this position"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "market",
                        "docs": [
                            "Link to market that manages the LP"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "fee_inside_last_pt",
                        "docs": [
                            "last fee calc position snapshot Q64.64"
                        ],
                        "type": "u128"
                    },
                    {
                        "name": "fee_inside_last_sy",
                        "docs": [
                            "last fee calc position snapshot Q64.64"
                        ],
                        "type": "u128"
                    },
                    {
                        "name": "lp_balance",
                        "docs": [
                            "Track the LP balance of the user here"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "tokens_owed_sy",
                        "type": "u64"
                    },
                    {
                        "name": "tokens_owed_pt",
                        "type": "u64"
                    },
                    {
                        "name": "lower_tick_idx",
                        "docs": [
                            "Lower tick of the position"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "upper_tick_idx",
                        "docs": [
                            "Upper tick of the position"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "farms",
                        "type": {
                            "defined": {
                                "name": "PersonalYieldTrackers"
                            }
                        }
                    },
                    {
                        "name": "share_trackers",
                        "docs": [
                            "Share trackers for each tick in range"
                        ],
                        "type": {
                            "defined": {
                                "name": "PrincipalShareTrackers"
                            }
                        }
                    },
                    {
                        "name": "crossing_split",
                        "docs": [
                            "Crossing split for positions that span the active tick.",
                            "When active (is_active() returns true), the position is logically split",
                            "into 3 segments with the crossing segment having reduced liquidity (L_actual).",
                            "When inactive, this field is ignored and standard fee calculation is used."
                        ],
                        "type": {
                            "defined": {
                                "name": "CrossingSplit"
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "MarketAccrueEmissionEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "owner_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "lp_position",
                        "type": "pubkey"
                    },
                    {
                        "name": "lp_balance",
                        "type": "u64"
                    },
                    {
                        "name": "lower_tick",
                        "type": "u32"
                    },
                    {
                        "name": "upper_tick",
                        "type": "u32"
                    },
                    {
                        "name": "tokens_owed_sy",
                        "type": "u64"
                    },
                    {
                        "name": "tokens_owed_pt",
                        "type": "u64"
                    },
                    {
                        "name": "farms",
                        "type": {
                            "defined": {
                                "name": "PersonalYieldTrackers"
                            }
                        }
                    },
                    {
                        "name": "share_trackers",
                        "type": {
                            "defined": {
                                "name": "PrincipalShareTrackers"
                            }
                        }
                    },
                    {
                        "name": "fee_inside_last_pt",
                        "type": "u128"
                    },
                    {
                        "name": "fee_inside_last_sy",
                        "type": "u128"
                    }
                ]
            }
        },
        {
            "name": "MarketAdminAction",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "SetStatus",
                        "fields": [
                            "u8"
                        ]
                    },
                    {
                        "name": "SetMaxLpSupply",
                        "fields": [
                            "u64"
                        ]
                    },
                    {
                        "name": "ChangeTreasuryTradeSyBpsFee",
                        "fields": [
                            "u16"
                        ]
                    },
                    {
                        "name": "ChangeLnFeeRateRoot",
                        "fields": [
                            "f64"
                        ]
                    },
                    {
                        "name": "ChangeCpiAccounts",
                        "fields": [
                            {
                                "name": "cpi_accounts",
                                "type": {
                                    "defined": {
                                        "name": "CpiAccounts"
                                    }
                                }
                            },
                            {
                                "name": "cpi_core_accounts",
                                "type": {
                                    "defined": {
                                        "name": "CpiCoreAccounts"
                                    }
                                }
                            }
                        ]
                    },
                    {
                        "name": "ChangeLiquidityNetBalanceLimits",
                        "fields": [
                            {
                                "name": "max_net_balance_change_negative_percentage",
                                "type": "u16"
                            },
                            {
                                "name": "max_net_balance_change_positive_percentage",
                                "type": "u32"
                            },
                            {
                                "name": "window_duration_seconds",
                                "type": "u32"
                            }
                        ]
                    },
                    {
                        "name": "ChangeAddressLookupTable",
                        "fields": [
                            "pubkey"
                        ]
                    },
                    {
                        "name": "ChangeEpsilonClamp",
                        "fields": [
                            "f64"
                        ]
                    },
                    {
                        "name": "ChangeMinLpTickAmount",
                        "fields": [
                            "u64"
                        ]
                    },
                    {
                        "name": "ChangeTickSpace",
                        "fields": [
                            "u32"
                        ]
                    }
                ]
            }
        },
        {
            "name": "MarketCollectEmissionEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "owner_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "lp_position",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_emission_owner",
                        "type": "pubkey"
                    },
                    {
                        "name": "emission_index",
                        "type": "u16"
                    },
                    {
                        "name": "amount_collected",
                        "type": "u64"
                    },
                    {
                        "name": "lp_balance",
                        "type": "u64"
                    },
                    {
                        "name": "lower_tick",
                        "type": "u32"
                    },
                    {
                        "name": "upper_tick",
                        "type": "u32"
                    },
                    {
                        "name": "tokens_owed_sy",
                        "type": "u64"
                    },
                    {
                        "name": "tokens_owed_pt",
                        "type": "u64"
                    },
                    {
                        "name": "farms",
                        "type": {
                            "defined": {
                                "name": "PersonalYieldTrackers"
                            }
                        }
                    },
                    {
                        "name": "share_trackers",
                        "type": {
                            "defined": {
                                "name": "PrincipalShareTrackers"
                            }
                        }
                    },
                    {
                        "name": "fee_inside_last_pt",
                        "docs": [
                            "Last snapshot of inside PT fee growth"
                        ],
                        "type": "u128"
                    },
                    {
                        "name": "fee_inside_last_sy",
                        "docs": [
                            "Last snapshot of inside SY fee growth"
                        ],
                        "type": "u128"
                    }
                ]
            }
        },
        {
            "name": "MarketEmission",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "token_escrow",
                        "docs": [
                            "Escrow account that receives the emissions from the SY program",
                            "And then passes them through to the user"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "lp_share_index",
                        "docs": [
                            "Index for converting LP shares into earned emissions"
                        ],
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "last_seen_staged",
                        "docs": [
                            "The difference between the staged amount and collected emission amount"
                        ],
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "MarketEmissions",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "trackers",
                        "type": {
                            "vec": {
                                "defined": {
                                    "name": "MarketEmission"
                                }
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "MarketFinancials",
            "docs": [
                "Financial parameters for the market"
            ],
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "expiration_ts",
                        "docs": [
                            "Expiration timestamp, which is copied from the vault associated with the PT"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "pt_balance",
                        "docs": [
                            "Balance of PT in the market",
                            "This amount is tracked separately to prevent bugs from token transfers directly to the market"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "sy_balance",
                        "docs": [
                            "Balance of SY in the market",
                            "This amount is tracked separately to prevent bugs from token transfers directly to the market"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "sy_user_balance",
                        "docs": [
                            "Balance of SY in the market without fees"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "liquidity_balance",
                        "docs": [
                            "Total balance of liquidity in the market"
                        ],
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "MarketThree",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "admin",
                        "type": "pubkey"
                    },
                    {
                        "name": "address_lookup_table",
                        "docs": [
                            "Address to ALT"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "mint_pt",
                        "docs": [
                            "Mint of the vault's PT token"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "mint_sy",
                        "docs": [
                            "Mint of the SY program's SY token"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "mint_yt",
                        "docs": [
                            "Mint of the vault's YT token"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "vault",
                        "docs": [
                            "Link to yield-stripping vault"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "token_pt_escrow",
                        "docs": [
                            "Token account that holds PT liquidity"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "token_sy_escrow",
                        "docs": [
                            "Pass-through token account for SY moving from the depositor to the SY program"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "token_yt_escrow",
                        "docs": [
                            "Pass-through token account for YT moving from the depositor to the core program"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "token_fee_treasury_sy",
                        "docs": [
                            "Token account that holds SY fees from trade"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "token_fee_treasury_pt",
                        "docs": [
                            "Token account that holds PT fees from trade"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "self_address",
                        "docs": [
                            "Authority for CPI calls owned by the market struct"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "ticks",
                        "docs": [
                            "Pubkey tick array account"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "signer_bump",
                        "docs": [
                            "Bump for signing the PDA"
                        ],
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    },
                    {
                        "name": "status_flags",
                        "type": "u8"
                    },
                    {
                        "name": "sy_program",
                        "docs": [
                            "Link to the SY program ID"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "exponent_core_program",
                        "docs": [
                            "Link to the exponent_core program ID"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "configuration_options",
                        "type": {
                            "defined": {
                                "name": "ConfigurationOptions"
                            }
                        }
                    },
                    {
                        "name": "financials",
                        "type": {
                            "defined": {
                                "name": "MarketFinancials"
                            }
                        }
                    },
                    {
                        "name": "emissions",
                        "type": {
                            "defined": {
                                "name": "MarketEmissions"
                            }
                        }
                    },
                    {
                        "name": "lp_farm",
                        "type": {
                            "defined": {
                                "name": "LpFarm"
                            }
                        }
                    },
                    {
                        "name": "cpi_sy_accounts",
                        "docs": [
                            "Record of CPI accounts"
                        ],
                        "type": {
                            "defined": {
                                "name": "CpiAccounts"
                            }
                        }
                    },
                    {
                        "name": "cpi_core_accounts",
                        "docs": [
                            "Record of CPI core accounts"
                        ],
                        "type": {
                            "defined": {
                                "name": "CpiCoreAccounts"
                            }
                        }
                    },
                    {
                        "name": "is_current_flash_swap",
                        "type": "bool"
                    },
                    {
                        "name": "liquidity_net_balance_limits",
                        "type": {
                            "defined": {
                                "name": "LiquidityNetBalanceLimits"
                            }
                        }
                    },
                    {
                        "name": "seed_id",
                        "docs": [
                            "Unique seed id for the market"
                        ],
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    }
                ]
            }
        },
        {
            "name": "MarketThreeInitEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "vault_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "rent_payer_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "admin_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "treasury_fee_bps",
                        "type": "u16"
                    },
                    {
                        "name": "sy_src",
                        "type": "pubkey"
                    },
                    {
                        "name": "pt_src",
                        "type": "pubkey"
                    },
                    {
                        "name": "current_spot_price",
                        "type": "f64"
                    },
                    {
                        "name": "tick_space",
                        "type": "u32"
                    },
                    {
                        "name": "seed_id",
                        "type": "u8"
                    },
                    {
                        "name": "ln_fee_rate_root",
                        "type": "f64"
                    },
                    {
                        "name": "min_lp_tick_amount",
                        "type": "u64"
                    },
                    {
                        "name": "epsilon_clamp",
                        "type": "f64"
                    },
                    {
                        "name": "max_lp_supply",
                        "type": "u64"
                    },
                    {
                        "name": "pt_init",
                        "type": "u64"
                    },
                    {
                        "name": "sy_init",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "MergeEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "owner",
                        "type": "pubkey"
                    },
                    {
                        "name": "vault",
                        "type": "pubkey"
                    },
                    {
                        "name": "sy_dst",
                        "type": "pubkey"
                    },
                    {
                        "name": "escrow_sy",
                        "type": "pubkey"
                    },
                    {
                        "name": "yt_src",
                        "type": "pubkey"
                    },
                    {
                        "name": "pt_src",
                        "type": "pubkey"
                    },
                    {
                        "name": "mint_yt",
                        "type": "pubkey"
                    },
                    {
                        "name": "mint_pt",
                        "type": "pubkey"
                    },
                    {
                        "name": "yield_position",
                        "type": "pubkey"
                    },
                    {
                        "name": "amount_py_in",
                        "type": "u64"
                    },
                    {
                        "name": "amount_sy_out",
                        "type": "u64"
                    },
                    {
                        "name": "sy_exchange_rate",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "pt_redemption_rate",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "total_sy_in_escrow",
                        "type": "u64"
                    },
                    {
                        "name": "pt_supply",
                        "type": "u64"
                    },
                    {
                        "name": "yt_balance",
                        "type": "u64"
                    },
                    {
                        "name": "sy_for_pt",
                        "type": "u64"
                    },
                    {
                        "name": "is_vault_active",
                        "type": "bool"
                    },
                    {
                        "name": "unix_timestamp",
                        "type": "i64"
                    }
                ]
            }
        },
        {
            "name": "ModifiedTick",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "tick_idx",
                        "type": "u32"
                    },
                    {
                        "name": "fee_grouth_pt_after",
                        "type": "u128"
                    },
                    {
                        "name": "fee_grouth_sy_after",
                        "type": "u128"
                    }
                ]
            }
        },
        {
            "name": "ModifiedTicks",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "fee_global_before_pt",
                        "type": "u128"
                    },
                    {
                        "name": "fee_global_before_sy",
                        "type": "u128"
                    },
                    {
                        "name": "fee_global_after_pt",
                        "type": "u128"
                    },
                    {
                        "name": "fee_global_after_sy",
                        "type": "u128"
                    },
                    {
                        "name": "ticks",
                        "type": {
                            "vec": {
                                "defined": {
                                    "name": "ModifiedTick"
                                }
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "ModifyFarmEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "admin_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "farm_index",
                        "type": "u16"
                    },
                    {
                        "name": "emission_mint",
                        "type": "pubkey"
                    },
                    {
                        "name": "old_token_rate",
                        "type": "u64"
                    },
                    {
                        "name": "new_token_rate",
                        "type": "u64"
                    },
                    {
                        "name": "old_expiry_timestamp",
                        "type": "u32"
                    },
                    {
                        "name": "new_expiry_timestamp",
                        "type": "u32"
                    },
                    {
                        "name": "token_difference",
                        "type": "i64"
                    }
                ]
            }
        },
        {
            "name": "Number",
            "docs": [
                "High precision number, stored as 4 u64 words in little endian"
            ],
            "repr": {
                "kind": "c"
            },
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "array": [
                            "u64",
                            4
                        ]
                    }
                ]
            }
        },
        {
            "name": "PersonalYieldTracker",
            "docs": [
                "Generic tracker for interest and emissions earned by deposits"
            ],
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "last_seen_index",
                        "docs": [
                            "The index is the per-share value of the SY token",
                            "Note that the YT balance must be converted to the equivalent SY balance"
                        ],
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "staged",
                        "docs": [
                            "Staged tokens that may be withdrawn"
                        ],
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "PersonalYieldTrackers",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "trackers",
                        "type": {
                            "vec": {
                                "defined": {
                                    "name": "PersonalYieldTracker"
                                }
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "PrincipalShare",
            "docs": [
                "Generic tracker for interest and emissions earned by deposits"
            ],
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "tick_idx",
                        "docs": [
                            "tick_idx"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "right_tick_idx",
                        "docs": [
                            "tick_idx"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "split_epoch",
                        "docs": [
                            "inserted_split_epoch"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "lp_share",
                        "docs": [
                            "lp share"
                        ],
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "emissions",
                        "type": {
                            "defined": {
                                "name": "PersonalYieldTrackers"
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "PrincipalShareTrackers",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "trackers",
                        "type": {
                            "vec": {
                                "defined": {
                                    "name": "PrincipalShare"
                                }
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "PrincipleDetails",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "administrators",
                        "type": {
                            "vec": "pubkey"
                        }
                    }
                ]
            }
        },
        {
            "name": "Principles",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "hot_admin",
                        "type": {
                            "defined": {
                                "name": "PrincipleDetails"
                            }
                        }
                    },
                    {
                        "name": "cold_admin",
                        "type": {
                            "defined": {
                                "name": "PrincipleDetails"
                            }
                        }
                    },
                    {
                        "name": "pause_admin",
                        "type": {
                            "defined": {
                                "name": "PrincipleDetails"
                            }
                        }
                    },
                    {
                        "name": "reserved1",
                        "type": {
                            "defined": {
                                "name": "PrincipleDetails"
                            }
                        }
                    },
                    {
                        "name": "reserved2",
                        "type": {
                            "defined": {
                                "name": "PrincipleDetails"
                            }
                        }
                    },
                    {
                        "name": "reserved3",
                        "type": {
                            "defined": {
                                "name": "PrincipleDetails"
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "SellPtEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "seller_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "amount_pt_in",
                        "type": "u64"
                    },
                    {
                        "name": "amount_base_out",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "SellYtEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "trader_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_yt_trader",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_pt_trader",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_sy_trader",
                        "type": "pubkey"
                    },
                    {
                        "name": "amount_yt_in",
                        "type": "u64"
                    },
                    {
                        "name": "amount_sy_received_from_merge",
                        "type": "u64"
                    },
                    {
                        "name": "amount_sy_spent_buying_pt",
                        "type": "u64"
                    },
                    {
                        "name": "amount_sy_out",
                        "type": "u64"
                    },
                    {
                        "name": "pt_borrowed_and_repaid",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "StripEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "depositor",
                        "type": "pubkey"
                    },
                    {
                        "name": "vault",
                        "type": "pubkey"
                    },
                    {
                        "name": "authority",
                        "type": "pubkey"
                    },
                    {
                        "name": "sy_src",
                        "type": "pubkey"
                    },
                    {
                        "name": "escrow_sy",
                        "type": "pubkey"
                    },
                    {
                        "name": "yt_dst",
                        "type": "pubkey"
                    },
                    {
                        "name": "pt_dst",
                        "type": "pubkey"
                    },
                    {
                        "name": "mint_yt",
                        "type": "pubkey"
                    },
                    {
                        "name": "mint_pt",
                        "type": "pubkey"
                    },
                    {
                        "name": "yield_position",
                        "type": "pubkey"
                    },
                    {
                        "name": "amount_sy_in",
                        "type": "u64"
                    },
                    {
                        "name": "amount_py_out",
                        "type": "u64"
                    },
                    {
                        "name": "sy_exchange_rate",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "total_sy_in_escrow",
                        "type": "u64"
                    },
                    {
                        "name": "pt_supply",
                        "type": "u64"
                    },
                    {
                        "name": "yt_balance",
                        "type": "u64"
                    },
                    {
                        "name": "all_time_high_sy_exchange_rate",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "sy_for_pt",
                        "type": "u64"
                    },
                    {
                        "name": "unix_timestamp",
                        "type": "i64"
                    }
                ]
            }
        },
        {
            "name": "SwapDirection",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "PtToSy"
                    },
                    {
                        "name": "SyToPt"
                    }
                ]
            }
        },
        {
            "name": "TradePtEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "trader_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_sy_trader",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_pt_trader",
                        "type": "pubkey"
                    },
                    {
                        "name": "swap_direction",
                        "type": {
                            "defined": {
                                "name": "SwapDirection"
                            }
                        }
                    },
                    {
                        "name": "is_current_flash_swap",
                        "type": "bool"
                    },
                    {
                        "name": "amount_in",
                        "type": "u64"
                    },
                    {
                        "name": "amount_out",
                        "type": "u64"
                    },
                    {
                        "name": "total_fee",
                        "type": "u64"
                    },
                    {
                        "name": "treasury_fee",
                        "type": "u64"
                    },
                    {
                        "name": "tick_after_trade",
                        "type": "u32"
                    },
                    {
                        "name": "current_spot_price",
                        "type": "f64"
                    },
                    {
                        "name": "sy_exchange_rate",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "modified_ticks",
                        "type": {
                            "defined": {
                                "name": "ModifiedTicks"
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "Vault",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "sy_program",
                        "docs": [
                            "Link to SY program"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "mint_sy",
                        "docs": [
                            "Mint for SY token"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "mint_yt",
                        "docs": [
                            "Mint for the vault-specific YT token"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "mint_pt",
                        "docs": [
                            "Mint for the vault-specific PT token"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "escrow_yt",
                        "docs": [
                            "Escrow account for holding deposited YT"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "escrow_sy",
                        "docs": [
                            "Escrow account that holds temporary SY tokens",
                            "As an interchange between users and the SY program"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "yield_position",
                        "docs": [
                            "Link to a vault-owned YT position",
                            "This account collects yield from all \"unstaked\" YT"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "address_lookup_table",
                        "docs": [
                            "Address lookup table key for vault"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "start_ts",
                        "docs": [
                            "start timestamp"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "duration",
                        "docs": [
                            "seconds duration"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "signer_seed",
                        "docs": [
                            "Seed for CPI signing"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "authority",
                        "docs": [
                            "Authority for CPI signing"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "signer_bump",
                        "docs": [
                            "bump for signer authority PDA"
                        ],
                        "type": {
                            "array": [
                                "u8",
                                1
                            ]
                        }
                    },
                    {
                        "name": "last_seen_sy_exchange_rate",
                        "docs": [
                            "Last seen SY exchange rate",
                            "This continues to be updated even after vault maturity to track SY appreciation for treasury collection"
                        ],
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "all_time_high_sy_exchange_rate",
                        "docs": [
                            "This is the all time high exchange rate for SY"
                        ],
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "final_sy_exchange_rate",
                        "docs": [
                            "This is the exchange rate for SY when the vault expires"
                        ],
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "total_sy_in_escrow",
                        "docs": [
                            "How much SY is held in escrow"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "sy_for_pt",
                        "docs": [
                            "The total SY set aside to back the PT holders",
                            "This value is updated on every operation that touches the PT supply or the last seen exchange rate"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "pt_supply",
                        "docs": [
                            "Total supply of PT"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "treasury_sy",
                        "docs": [
                            "Amount of SY staged for the treasury"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "uncollected_sy",
                        "docs": [
                            "SY that has been earned by YT, but not yet collected"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "treasury_sy_token_account",
                        "type": "pubkey"
                    },
                    {
                        "name": "interest_bps_fee",
                        "type": "u16"
                    },
                    {
                        "name": "min_op_size_strip",
                        "type": "u64"
                    },
                    {
                        "name": "min_op_size_merge",
                        "type": "u64"
                    },
                    {
                        "name": "status",
                        "type": "u8"
                    },
                    {
                        "name": "emissions",
                        "type": {
                            "vec": {
                                "defined": {
                                    "name": "EmissionInfo"
                                }
                            }
                        }
                    },
                    {
                        "name": "cpi_accounts",
                        "type": {
                            "defined": {
                                "name": "CpiAccounts"
                            }
                        }
                    },
                    {
                        "name": "claim_limits",
                        "type": {
                            "defined": {
                                "name": "ClaimLimits"
                            }
                        }
                    },
                    {
                        "name": "max_py_supply",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "WithdrawLiquidityEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "withdrawer_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_pt_withdrawer",
                        "type": "pubkey"
                    },
                    {
                        "name": "token_sy_withdrawer",
                        "type": "pubkey"
                    },
                    {
                        "name": "liquidity_to_remove",
                        "type": "u64"
                    },
                    {
                        "name": "amount_pt_out",
                        "docs": [
                            "Total PT amount removed (distributed across ticks in range)"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "amount_sy_out",
                        "docs": [
                            "Total SY amount removed (distributed across ticks in range)"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "new_lp_supply",
                        "type": "u64"
                    },
                    {
                        "name": "lower_tick",
                        "docs": [
                            "Lower tick boundary of the position"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "upper_tick",
                        "docs": [
                            "Upper tick boundary of the position"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "lp_position",
                        "docs": [
                            "LP position account address"
                        ],
                        "type": "pubkey"
                    },
                    {
                        "name": "lp_balance_after",
                        "docs": [
                            "Total LP balance after this withdrawal"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "fee_sy_collected",
                        "docs": [
                            "SY fees collected during this withdrawal"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "fee_pt_collected",
                        "docs": [
                            "PT fees collected during this withdrawal"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "tokens_owed_sy",
                        "docs": [
                            "Remaining unclaimed SY fees (after collection, should be 0)"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "tokens_owed_pt",
                        "docs": [
                            "Remaining unclaimed PT fees (after collection, should be 0)"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "farms",
                        "type": {
                            "defined": {
                                "name": "PersonalYieldTrackers"
                            }
                        }
                    },
                    {
                        "name": "share_trackers",
                        "type": {
                            "defined": {
                                "name": "PrincipalShareTrackers"
                            }
                        }
                    },
                    {
                        "name": "fee_inside_last_pt",
                        "docs": [
                            "Last snapshot of inside PT fee growth"
                        ],
                        "type": "u128"
                    },
                    {
                        "name": "fee_inside_last_sy",
                        "docs": [
                            "Last snapshot of inside SY fee growth"
                        ],
                        "type": "u128"
                    }
                ]
            }
        },
        {
            "name": "WithdrawLiquidityReturnData",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "liquidity_to_remove",
                        "type": "u64"
                    },
                    {
                        "name": "amount_pt_out",
                        "docs": [
                            "Total PT amount removed (distributed across ticks in range)"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "amount_sy_out",
                        "docs": [
                            "Total SY amount removed (distributed across ticks in range)"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "new_lp_supply",
                        "type": "u64"
                    },
                    {
                        "name": "lower_tick",
                        "docs": [
                            "Lower tick boundary of the position"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "upper_tick",
                        "docs": [
                            "Upper tick boundary of the position"
                        ],
                        "type": "u32"
                    },
                    {
                        "name": "fee_sy_collected",
                        "docs": [
                            "LP position account address",
                            "SY fees collected during this withdrawal"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "fee_pt_collected",
                        "docs": [
                            "PT fees collected during this withdrawal"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "tokens_owed_sy",
                        "docs": [
                            "Remaining unclaimed SY fees (after collection, should be 0)"
                        ],
                        "type": "u64"
                    },
                    {
                        "name": "tokens_owed_pt",
                        "docs": [
                            "Remaining unclaimed PT fees (after collection, should be 0)"
                        ],
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "WrapperBuyYtEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "buyer_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "yt_out_amount",
                        "type": "u64"
                    },
                    {
                        "name": "base_in_amount",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "WrapperProvideLiquidityBaseEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "user_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "lp_position_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "amount_base_in",
                        "type": "u64"
                    },
                    {
                        "name": "trade_amount_pt_out",
                        "type": "u64"
                    },
                    {
                        "name": "trade_amount_sy_in",
                        "type": "u64"
                    },
                    {
                        "name": "amount_lp_out",
                        "type": "u64"
                    },
                    {
                        "name": "amount_pt_in",
                        "type": "u64"
                    },
                    {
                        "name": "amount_sy_in",
                        "type": "u64"
                    },
                    {
                        "name": "asset_value_lp_in",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "asset_value_pt_in",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "asset_value_sy_in",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "WrapperProvideLiquidityClassicEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "user_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "amount_base_in",
                        "type": "u64"
                    },
                    {
                        "name": "amount_lp_out",
                        "type": "u64"
                    },
                    {
                        "name": "amount_pt_in",
                        "type": "u64"
                    },
                    {
                        "name": "amount_sy_in",
                        "type": "u64"
                    },
                    {
                        "name": "asset_value_lp_in",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "asset_value_pt_in",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "asset_value_sy_in",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "lp_position_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "sy_exchange_rate",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    }
                ]
            }
        },
        {
            "name": "WrapperProvideLiquidityEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "user_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "amount_base_in",
                        "type": "u64"
                    },
                    {
                        "name": "amount_lp_out",
                        "type": "u64"
                    },
                    {
                        "name": "amount_yt_out",
                        "type": "u64"
                    },
                    {
                        "name": "amount_pt_in",
                        "type": "u64"
                    },
                    {
                        "name": "amount_sy_in",
                        "type": "u64"
                    },
                    {
                        "name": "asset_value_lp_in",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "asset_value_pt_in",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "asset_value_sy_in",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "asset_value_yt_out",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "lp_position_address",
                        "type": "pubkey"
                    }
                ]
            }
        },
        {
            "name": "WrapperSellYtEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "seller_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "yt_in_amount",
                        "type": "u64"
                    },
                    {
                        "name": "amount_base_out",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "WrapperWithdrawLiquidityClassicEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "user_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "amount_base_out",
                        "type": "u64"
                    },
                    {
                        "name": "amount_lp_in",
                        "type": "u64"
                    },
                    {
                        "name": "amount_pt_out",
                        "type": "u64"
                    },
                    {
                        "name": "amount_sy_out",
                        "type": "u64"
                    },
                    {
                        "name": "asset_value_lp_out",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "asset_value_pt_out",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "asset_value_sy_out",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "lp_position_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "sy_exchange_rate",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "fee_sy_collected",
                        "type": "u64"
                    },
                    {
                        "name": "fee_pt_collected",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "WrapperWithdrawLiquidityEvent",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "user_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "market_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "amount_base_out",
                        "type": "u64"
                    },
                    {
                        "name": "amount_lp_in",
                        "type": "u64"
                    },
                    {
                        "name": "amount_pt_out",
                        "type": "u64"
                    },
                    {
                        "name": "amount_sy_out",
                        "type": "u64"
                    },
                    {
                        "name": "asset_value_lp_out",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "asset_value_pt_out",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "asset_value_sy_out",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "lp_position_address",
                        "type": "pubkey"
                    },
                    {
                        "name": "sy_exchange_rate",
                        "type": {
                            "defined": {
                                "name": "Number"
                            }
                        }
                    },
                    {
                        "name": "fee_sy_collected",
                        "type": "u64"
                    },
                    {
                        "name": "fee_pt_collected",
                        "type": "u64"
                    }
                ]
            }
        }
    ]
}
